import mitt, { Emitter } from 'mitt';
import { AppEvent } from './constants.ts';
import { GameEvent } from '@/3d-components/constants.ts';
import { IAIPlanLimit, INavigate, INotification } from '@/common/interface.ts';

export * from './constants.ts';

type EmitterEvent = {
    [AppEvent.NAVIGATE]: INavigate;
    [AppEvent.SHOW_NOTIFICATION]: INotification;
    [AppEvent.AI_PLAN_LIMIT]: IAIPlanLimit;
    [GameEvent.AI_VOICE_PLAYING]: {
        audio_url: string;
        name: string;
    };
    [GameEvent.AI_PAUSE_VOICE]: void;
    [GameEvent.AI_CONTEXT_TRIGGER_OPENING]: void;
    [GameEvent.AUDIO_PLAYER_PLAY]: {
        audioSrc: string;
        audioElement: HTMLAudioElement;
        duration: number;
    };
    [GameEvent.AUDIO_PLAYER_PAUSE]: {
        audioSrc: string;
    };
    [GameEvent.AUDIO_PLAYER_END]: {
        audioSrc: string;
    };
};

export type CustomEmitter = Emitter<EmitterEvent>;

export const emitter: CustomEmitter = mitt<EmitterEvent>();
